import HerobannerList from './List'
import HerobannerEdit from './Edit'
import HerobannerCreate from './Create'

const HerobannersResource = {
  list: HerobannerList,
  edit: HerobannerEdit,
  create: HerobannerCreate,
}

export default HerobannersResource
